module.exports = __webpack_public_path__ + "img/plugandplay.dca17101.png";